/**
 * Sammelstelle für alles, was nach dem HTML-Rendern noch asynchron nachgeladen
 * wird: Mermaid-Diagramme und TikZ-Grafiken. Aufrufer brauchen nur
 * `hydrateDiagrams(container)` – am besten leicht verzögert (Tippen).
 */

import { hydrateMermaid } from "./mermaid";
import { hydrateTikz } from "./tikz";
import { hydrateCode } from "./highlight";

export async function hydrateDiagrams(root: HTMLElement): Promise<void> {
  await Promise.all([hydrateMermaid(root), hydrateTikz(root), hydrateCode(root)]);
}

export { hydrateMermaid, hydrateTikz, hydrateCode };
